export interface ApiGetMermaidRequest {
    task_id: string;
    tech_desc: string;
    pn: string;
}

export type ApiGetMermaidResponse = string;

export const GetMermaid = Symbol('GetMermaid');

export interface GetMermaid {
    getMermaid(data: ApiGetMermaidRequest): Promise<ApiGetMermaidResponse>;
}
